require('./usercard-list.component.scss');

class UsercardListController {
  constructor(
    $scope,
    RouterService,
    UsercardService,
    PermissionService
  ) {
    this.$scope = $scope;
    this.usercards = UsercardService;
    this.$scope.usercards = this.usercards;
    this.permission = PermissionService;
    this.router = RouterService;
    this.filter_value = null;
    this.full_name_filter_value = '';
    this.ordering = [];
    //         console.log('Hello from UsercardListController');
    if (this.usercards.items && this.usercards.items.length)
      this.items = this.usercards.items;
    else
      this.usercards.loadList(() => {
        this.items = this.usercards.items;
        // this.$scope.$digest();
      });
  }

  selectItem(value) {
    //     console.log(value);
    this.router.search('usercard', value);
    //     this.usercards.selectItem(value);
  }

  setFilter(filter_value) {
    console.log('setFilter ' + filter_value);
    this.filter_value = filter_value;
    this.full_name_filter_value = '';
    if (filter_value) {
      this.items = this.usercards.items.filter(item => item.ad_attributes.office == this.filter_value);
    } else {
      this.items = this.usercards.items;
    }
  }

  setOrder(ordering) {
    let direction = '';
    if (this.ordering.includes(ordering)) {
      direction = '-';
    }
    const new_ordering = this.ordering.filter(item => {
      return (item != ordering) && (item != '-' + ordering);
    });
    new_ordering.unshift(direction + ordering);
    this.ordering = new_ordering;
    //         console.log(new_ordering);
  }

  sortComparator(a, b) {
    let v = 1;
    if ((!a.value && !b.value) || (a.value == 'null' && b.value == 'null')) {
      v = 1;
    } else if (!a.value || a.value == 'null') {
      v = -1;
    } else if (!b.value || b.value == 'null') {
      v = 1;
    } else v = a.value < b.value ? -1 : 1;
    //         console.log(a.value, b.value, v);
    return v;
  }

  columnSortingStyle(ordering) {
    let style = 'icon-resize-vertical';
    if (this.ordering.includes(ordering)) {
      style = 'icon-up';
    }
    if (this.ordering.includes('-' + ordering)) {
      style = 'icon-down';
    }
    return style;
  }

  filterByFullName() {
    console.log(this.full_name_filter_value);
    this.filter_value = null;
    this.items = this.full_name_filter_value ?
      this.usercards.items.filter(i => i.full_name.includes(this.full_name_filter_value)) :
      this.items = this.usercards.items;
  }

}

export function UsercardListComponent() {
  return {
    restrict: 'E',
    template: require('./usercard-list.component.html'),
    scope: true,
    controller: UsercardListController,
    controllerAs: '$ctrl',
    bindToController: {
      dim: '<',
      model: '<',
    },
  };
}



// WEBPACK FOOTER //
// ./src/usercard/usercard-list.component.js